import { motion } from "framer-motion";
import { Flame, CalendarCheck, Trophy } from "lucide-react";

export default function StreakCard({ profile }) {
  const current = profile.current_streak || 0;
  const longest = profile.longest_streak || 0;
  const votedToday = !!profile.voted_today;
  const hot = current >= 3;
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-2xl shadow-card p-5 mb-4 text-white"
      style={{ background: hot ? "linear-gradient(120deg, #7c2d12 0%, #ea580c 60%, #f59e0b 130%)" : "linear-gradient(120deg, #172033 0%, #1e293b 70%, #334155 130%)" }}
      data-testid="streak-card"
    >
      <motion.div
        className="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-white/10 blur-2xl"
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      />
      <div className="relative flex items-center gap-4">
        <motion.div
          className="w-14 h-14 rounded-2xl bg-white/15 flex items-center justify-center shrink-0"
          animate={hot ? { rotate: [-4, 4, -4], scale: [1, 1.06, 1] } : {}}
          transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
        >
          <Flame className={`w-7 h-7 ${hot ? "text-amber-200" : "text-orange-400"}`} fill={current > 0 ? "currentColor" : "none"} />
        </motion.div>
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline gap-2">
            <span className="font-heading text-4xl leading-none" data-testid="streak-current">{current}</span>
            <span className="text-sm font-semibold text-white/80">day{current === 1 ? "" : "s"} streak</span>
          </div>
          <p className="text-xs text-white/70 mt-1" data-testid="streak-status">
            {votedToday
              ? "Voted today — streak locked in."
              : current > 0 ? "Vote today to keep the streak alive." : "Cast a vote today to start a streak."}
          </p>
        </div>
        <div className="hidden sm:flex flex-col gap-1.5 text-right shrink-0">
          <span className="flex items-center justify-end gap-1 text-[11px] text-white/80">
            <Trophy className="w-3 h-3" /> Best <b data-testid="streak-longest">{longest}</b>
          </span>
          <span className="flex items-center justify-end gap-1 text-[11px] text-white/80">
            <CalendarCheck className="w-3 h-3" /> <b>{profile.active_days || 0}</b> active days
          </span>
        </div>
      </div>
    </motion.div>
  );
}
